/**
 * @flow
 * @relayHash 7e658d3e870f31cb1308ee0cdc9ba2ff
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AssociatedEntitiesTable_relayQueryResponse = {|
  +repository: ?{|
    +files: ?{|
      +hits: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +annotations: ?{|
              +hits: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +annotation_id: ?string;
                    +entity_id: ?string;
                  |};
                |}>;
              |};
            |};
            +associated_entities: ?{|
              +hits: ?{|
                +total: number;
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +case_id: ?string;
                    +entity_id: ?string;
                    +entity_submitter_id: ?string;
                    +entity_type: ?string;
                  |};
                |}>;
              |};
            |};
          |};
        |}>;
      |};
    |};
  |};
|};
*/


/*
query AssociatedEntitiesTable_relayQuery(
  $filters: FiltersArgument
  $aeTable_filters: FiltersArgument
  $aeTable_size: Int
  $aeTable_offset: Int
) {
  repository {
    files {
      hits(filters: $filters, first: 1) {
        edges {
          node {
            annotations {
              hits(first: 99) {
                edges {
                  node {
                    annotation_id
                    entity_id
                    id
                  }
                }
              }
            }
            associated_entities {
              hits(filters: $aeTable_filters, first: $aeTable_size, offset: $aeTable_offset) {
                total
                edges {
                  node {
                    case_id
                    entity_id
                    entity_submitter_id
                    entity_type
                    id
                  }
                }
              }
            }
            id
          }
        }
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "filters",
        "type": "FiltersArgument",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "aeTable_filters",
        "type": "FiltersArgument",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "aeTable_size",
        "type": "Int",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "aeTable_offset",
        "type": "Int",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssociatedEntitiesTable_relayQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Repository",
        "name": "repository",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Files",
            "name": "files",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "filters",
                    "variableName": "filters",
                    "type": "FiltersArgument"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  }
                ],
                "concreteType": "FileConnection",
                "name": "hits",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "FileEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "File",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "FileAnnotations",
                            "name": "annotations",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 99,
                                    "type": "Int"
                                  }
                                ],
                                "concreteType": "FileAnnotationConnection",
                                "name": "hits",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FileAnnotationEdge",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FileAnnotation",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "annotation_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "entity_id",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "hits{\"first\":99}"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "AssociatedEntities",
                            "name": "associated_entities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "filters",
                                    "variableName": "aeTable_filters",
                                    "type": "FiltersArgument"
                                  },
                                  {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "aeTable_size",
                                    "type": "Int"
                                  },
                                  {
                                    "kind": "Variable",
                                    "name": "offset",
                                    "variableName": "aeTable_offset",
                                    "type": "Int"
                                  }
                                ],
                                "concreteType": "AssociatedEntityConnection",
                                "name": "hits",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "total",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssociatedEntityEdge",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AssociatedEntity",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "case_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "entity_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "entity_submitter_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "entity_type",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AssociatedEntitiesTable_relayQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "filters",
        "type": "FiltersArgument",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "aeTable_filters",
        "type": "FiltersArgument",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "aeTable_size",
        "type": "Int",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "aeTable_offset",
        "type": "Int",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "AssociatedEntitiesTable_relayQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Repository",
        "name": "repository",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Files",
            "name": "files",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "filters",
                    "variableName": "filters",
                    "type": "FiltersArgument"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  }
                ],
                "concreteType": "FileConnection",
                "name": "hits",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "FileEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "File",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "FileAnnotations",
                            "name": "annotations",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 99,
                                    "type": "Int"
                                  }
                                ],
                                "concreteType": "FileAnnotationConnection",
                                "name": "hits",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FileAnnotationEdge",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FileAnnotation",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "annotation_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "entity_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "id",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "hits{\"first\":99}"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "AssociatedEntities",
                            "name": "associated_entities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "filters",
                                    "variableName": "aeTable_filters",
                                    "type": "FiltersArgument"
                                  },
                                  {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "aeTable_size",
                                    "type": "Int"
                                  },
                                  {
                                    "kind": "Variable",
                                    "name": "offset",
                                    "variableName": "aeTable_offset",
                                    "type": "Int"
                                  }
                                ],
                                "concreteType": "AssociatedEntityConnection",
                                "name": "hits",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "total",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssociatedEntityEdge",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AssociatedEntity",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "case_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "entity_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "entity_submitter_id",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "entity_type",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "args": null,
                                            "name": "id",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query AssociatedEntitiesTable_relayQuery(\n  $filters: FiltersArgument\n  $aeTable_filters: FiltersArgument\n  $aeTable_size: Int\n  $aeTable_offset: Int\n) {\n  repository {\n    files {\n      hits(filters: $filters, first: 1) {\n        edges {\n          node {\n            annotations {\n              hits(first: 99) {\n                edges {\n                  node {\n                    annotation_id\n                    entity_id\n                    id\n                  }\n                }\n              }\n            }\n            associated_entities {\n              hits(filters: $aeTable_filters, first: $aeTable_size, offset: $aeTable_offset) {\n                total\n                edges {\n                  node {\n                    case_id\n                    entity_id\n                    entity_submitter_id\n                    entity_type\n                    id\n                  }\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/AssociatedEntitiesTable/__generated__/AssociatedEntitiesTable_relayQuery.graphql.js